<template>
  <div class="info">
    <HomePic/>
    <BreadNav/>
    <div class="sub-main">
      <LoginBox v-if="!isLogin"/>
      <Random v-if="isLogin"/>
    </div>
  </div>
</template>

<style lang="less">
</style>

<script>
import HomePic from '@/components/style1/HomePic.vue';
import BreadNav from '@/components/style1/BreadNav.vue';
import LoginBox from '@/components/style1/LoginBox.vue';
import Random from '@/components/style1/Random.vue';
import { mapState } from 'vuex';

export default {
  name: 'NewsDetail',
  components: {
    HomePic,
    BreadNav,
    LoginBox,
    Random,
  },
  data() {
    return {
      e: 1,
    };
  },
  mounted() {
    console.log(this.isLogin);
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin',
    }),
  },
  methods: {},
};
</script>
